import React from 'react'
import logo from '../img/logo.svg'
import logo_new_year from '../img/logo_new-year.svg'
import Link from "gatsby-link"

export default class Navigation extends React.Component {

	hasClass(ele, cls) {
	    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
	}

	addClass(ele, cls) {
	    if (!this.hasClass(ele, cls)) ele.className += " " + cls;
	}

	removeClass(ele, cls) {
	    if (this.hasClass(ele, cls)) {
	        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
	        ele.className = ele.className.replace(reg, '');
	    }
	}

	toggleMenu() {
	    var ele = document.getElementsByTagName('body')[0];
	    if (!this.hasClass(ele, "open")) {
	        this.addClass(ele, "open");
	    } else {
	        this.removeClass(ele, "open");
	    }
	}

 	handleClick(e) {
        this.toggleMenu();
        e.stopPropagation();
    }

	render() {
		return (

		<div className="nav">
			<div className="container">
				<div className="nav-menu-button">
					<button className="nav-menu-toggle" onClick={this.handleClick.bind(this)} type="button"><span></span><span></span><span></span></button>
				</div>
				<div className="nav-logo">
					<Link to="/" title="India.Uvocorp.com"><img src={logo} alt="India.Uvocorp.com" /></Link>
				</div>
				<div className="nav-menu">
					<ul className="nav-menu-list">
						<li><a href={`${process.env.GATSBY_API_URL}/about.html`}>About</a></li>
						<li><a href={`${process.env.GATSBY_API_URL}/hiring.html`}>Hiring</a></li>
						<li><a href={`${process.env.GATSBY_API_URL}/vacancies.html`}>Vacancies</a></li>
						<li><a href={`${process.env.GATSBY_API_URL}/faq.html`}>FAQ</a></li>
						<li><a href={`${process.env.GATSBY_API_URL}/contacts.html`}>Contacts</a></li>
						<li><a href={`${process.env.GATSBY_API_URL}/reviews.html`}>Reviews</a></li>
						<li><a href="https://www.uvocorp.com/freelancewriting/">Blog</a></li>
						<li><a href={`${process.env.GATSBY_API_URL}/register_email.html`}>Register</a></li>
					</ul>
					<a href={`${process.env.GATSBY_API_URL}/login.html`} className="nav-menu-login">Log In</a>
				</div>
			</div>
		</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/layouts/navigation.js